<template>
  <div :id="name" class="map"></div>
</template>

<script>
/* eslint-disable no-undef */
// import 'apple-mapkit-js';
import { mapState } from 'vuex';

export default {
  name: 'MapKitMap',
  props: {
    name: String,
    lat: {
      type: Number,
    },
    long: {
      type: Number,
    },
    img: {
      type: String,
      default: '/img/macbookpro.svg',
    },
    title: {
      type: String,
      default: 'Asset Location',
    },
    color: {
      type: String,
      default: '#47576C',
    },
    defaultCenter: {
      type: Object,
      default() {
        return {
          lat: 39.8283,
          long: -98.5795,
        };
      },
    },
  },
  watch: {
    lat() {
      this.setMarker();
    },
    long() {
      this.setMarker();
    },
  },
  data() {
    return {
      map: null,
      mapName: `${this.name}-map`,
      point: null,
    };
  },
  computed: {
    ...mapState('mk', ['mapkit']),
  },
  methods: {
    setRegion(lat, long, span) {
      const initPoint = new this.mapkit.Coordinate(lat, long);
      const initSpan = new this.mapkit.CoordinateSpan(span, span);
      const initRegion = new this.mapkit.CoordinateRegion(initPoint, initSpan);
      this.map.setCenterAnimated(initPoint);
      this.map.setRegionAnimated(initRegion);
    },
    setMarker() {
      // Remove the point if one was already set
      if (this.point !== null) {
        this.map.removeAnnotation(this.point);
      }

      this.point = new this.mapkit.MarkerAnnotation(new mapkit.Coordinate(this.lat, this.long), {
        draggable: false,
        selected: true,
        title: this.title,
        color: this.color,
        glyphImage: { 1: this.img },
      });

      this.map.addAnnotation(this.point);
      this.setRegion(this.lat, this.long, 0.1);
    },
    createMap() {
      this.map = new this.mapkit.Map(this.name, {
        isZoomEnabled: true,
        isScrollEnabled: true,
        showsUserLocationControl: true,
      });

      // If we have a marker, set it, else set the map to center of the United States
      if (this.lat !== null && this.long !== null) {
        this.setMarker(this.lat, this.long);
      } else {
        this.setRegion(this.defaultCenter.lat, this.defaultCenter.long, 80);
      }
    },
  },
  async mounted() {
    if (this.mapkit) {
      this.createMap();
    }
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
  min-height: 225px; // This height is necessary to get the controls
}
</style>
